/**
 * 좌측 메뉴. 아이콘은 여기 두지 않는다 — 상수가 lucide 에 묶이지 않도록
 * app-nav-list 에서 href 로 연결한다.
 */
export interface NavItem {
  name: string;
  href: string;
}

export interface NavGroup {
  label: string;
  items: NavItem[];
}

export const APP_NAV: NavGroup[] = [
  {
    label: "영업",
    items: [
      { name: "대시보드", href: "/app" },
      { name: "고객", href: "/app/customers" },
      { name: "견적", href: "/app/quotes" },
      { name: "계약", href: "/app/contracts" },
      { name: "시공사례", href: "/app/portfolio" },
      { name: "유입 분석", href: "/app/insights" },
    ],
  },
  {
    label: "시공",
    items: [
      { name: "현장", href: "/app/projects" },
      { name: "공정 표준", href: "/app/standards" },
    ],
  },
  {
    label: "관리",
    items: [{ name: "설정", href: "/app/settings" }],
  },
];

export interface NavMatch {
  group: string;
  item: NavItem;
}

// 경로 조각 경계로 앞부분이 맞는 항목 중 가장 긴 하나 — /app 이 하위 경로 전부를 켜지 않게 한다.
export const findNavMatch = (pathname: string | null, nav: NavGroup[] = APP_NAV): NavMatch | null => {
  if (!pathname) return null;
  let best: NavMatch | null = null;
  for (const group of nav) {
    for (const item of group.items) {
      const hit = pathname === item.href || pathname.startsWith(`${item.href}/`);
      if (hit && (!best || item.href.length > best.item.href.length)) best = { group: group.label, item };
    }
  }
  return best;
};

// 메뉴 아래 한 단계 더 들어간 화면의 이름 — 헤더 브레드크럼 끝에 붙인다(본문에 두 번째 브레드크럼을 두지 않는다, #25).
const SUB_PAGES: readonly [RegExp, string][] = [
  [/^\/app\/projects\/[^/]+\/today$/, "오늘 기록"],
  [/^\/app\/projects\/[^/]+\/messages$/, "고객 대화"],
  [/^\/app\/projects\/[^/]+\/notice$/, "공사 안내문"],
  [/^\/app\/projects\/[^/]+\/camera$/, "촬영"],
  [/^\/app\/today$/, "오늘"],
];

export const subPageName = (pathname: string | null): string | null =>
  (pathname && SUB_PAGES.find(([pattern]) => pattern.test(pathname))?.[1]) || null;
